<ngx-spinner type="square-jelly-box"></ngx-spinner>

<router-outlet></router-outlet>